<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog.active"
      :width="getKnowledgeBaseLocation ? '100%' : 550"
      max-width="900pt"
    >
      <v-card>
        <div class="container" v-if="getKnowledgeBaseLocation">
          <iframe
            class="responsive-iframe"
            :src="getKnowledgeBaseLocation"
            frameborder="0"
            allowfullscreen
            allowautoplay
            allowtransparency
          ></iframe>
        </div>
        <v-card-title v-else>
          {{
            $t(
              "components.dialogs.helpDialog.helpIsCurrentlyNotAvailableForThisSectionPleaseTryAgainLater"
            )
          }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">
            {{ $t("components.dialogs.helpDialog.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["dialog"],
  data() {
    return {
      link: null,
    };
  },
  created() {},
  computed: {
    filterKnowledgeBase() {
      return this.getKnowledgeBase.filter((knowledgeBase) => {
        return knowledgeBase.location_id === this.dialog.location;
      });
    },
    getKnowledgeBaseLocation: {
      get: function () {
        let location;
        if (this.filterKnowledgeBase.length !== 0) {
          location = this.filterKnowledgeBase[0].link;
        } else {
          location = null;
          if (this.dialog.location !== null) {
            console.error(this.getKnowledgeBase, this.dialog.location);
          }
        }
        return location;
      },
    },
    ...mapGetters(["getKnowledgeBase"]),
  },
  methods: {
    close() {
      this.$emit("close", "close");
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.container {
  position: relative;
  width: 100%;
  padding-top: 50%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  overflow: hidden;
}
</style>
